module.exports = __webpack_public_path__ + "img/service-img-title.c08bb786.png";